import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TowerService} from "../../api/service/tower.service";
import {NavigationService} from "../../shared/navigation.service";

@Component({
  selector: 'app-callback',
  template: ''
})
export class CallbackComponent implements OnInit {


  constructor(private router: Router,
              private route: ActivatedRoute,
              private towerService: TowerService,
              private navigationService: NavigationService) {
  }

  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      this.towerService.obtainToken(fragment).subscribe(
        response => {
          this.navigationService.setToken(response);
          this.towerService.setAccessToken(response.accessToken);
          this.router.navigate(['/home']);
        }, error => {
          alert('Erreur durant la connexion');
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/page/callback/callback.component.ts